/**
 *	(c) 2024 Приволжский Исследовательский Медицинский Университет
 *
 *	@file: consts.js
 *  @description: Этот файл является частью клиентской стороны проекта. src Относится к части, которая содержит функции общего назначения - утилиты. В этом файле находятся предопределённые константы - строки, используемые во многих других местах.
 *	@author: Белов Михаил Александрович, Горбас Александр Петрович, Манжос Геннадий Юрьевич
*/
export const LOGIN_ROUTE = '/login';
export const LOGOUT_ROUTE = '/logout';
export const REGISTRATION_ROUTE = '/registration';
export const ACCOUNT_ROUTE = '/account';
export const PASSWORD_RESTORE_ROUTE = '/restore';

//-----------

export const ABOUT_APPLICATION_ROUTE = '/about_application'
export const CONTACTS_ROUTE = '/contacts'
export const SUPPORT_ROUTE = '/support'
export const SUPPORT_GUIDE_ROUTE = '/support_guide'
export const DEMO_VERSION_ROUTE = '/demo_version'
export const System_Requirements_ROUTE = '/system_requirements';
export const Agreement_ROUTE = '/agreement';
export const News_ROUTE = '/news';

//-----------

export const Epidemics_Map_ROUTE = '/epidemics'

//-----------

export const START_ROUTE = '/'

//-----------

export const PIMU_CATEGORIES_ROUTE = '/pimu'

//-----------

export const ECG_CATEGORIES_ROUTE = '/ecg'
export const ECG_DATA_ENTRIE = '/entrie'

//-----------

export const TestExtra_CATEGORIES_ROUTE = '/testExtra'
export const TestExtra_DATA_ENTRIE = '/entrie'

//-----------

export const Biology_CATEGORIES_ROUTE = '/biology'
export const Biology_DATA_ENTRIE = '/entrie'

//-----------

export const Patanatomy_CATEGORIES_ROUTE = '/patanatomy'
export const Patanatomy_DATA_ENTRIE = '/entrie'

//-----------

export const Gistology_CATEGORIES_ROUTE = '/gistology'
export const Gistology_DATA_ENTRIE = '/entrie'

//-----------

export const Endoscopy_CATEGORIES_ROUTE = '/endoscopy'
export const Endoscopy_DATA_ENTRIE = '/entrie'

//-----------

export const KLD_CATEGORIES_ROUTE = '/kld';
export const KLD_DATA_ENTRIE = '/entrie';

//-----------

export const Microbiology_CATEGORIES_ROUTE = '/microbiology';
export const Microbiology_DATA_ENTRIE = '/entrie';

//-----------

export const SkinDisease_CATEGORIES_ROUTE = '/skindisease';
export const SkinDisease_DATA_ENTRIE = '/entrie';

//-----------

export const Testing_PAGE_ROUTE = '/testing';

//-----------

export const Modelling_CATEGORIES_ROUTE = '/modelling';
export const Modelling_DATA_ENTRIE = '/entrie';

//-----------

export const RadiologyDiag_CATEGORIES_ROUTE = '/radiology';
export const RadiologyDiag_DATA_ENTRIE = '/entrie';

//-----------

export const Botany_CATEGORIES_ROUTE = '/botany';
export const Botany_DATA_ENTRIE = '/entrie';

//-----------

export const Ultrasound_CATEGORIES_ROUTE = '/ultrasound';
export const Ultrasound_DATA_ENTRIE = '/entrie';

//-----------

export const Genetics_CATEGORIES_ROUTE = '/genetics';
export const Genetics_DATA_ENTRIE = '/entrie';

//-----------

export const Ophthalmology_CATEGORIES_ROUTE = '/ophthalmology';
export const Ophthalmology_DATA_ENTRIE = '/entrie';

//-----------

export const Spo_CATEGORIES_ROUTE = '/spo';
export const Spo_DATA_ENTRIE = '/entrie';

//-----------

export const Pharmacology_CATEGORIES_ROUTE = '/pharmacology';
export const Pharmacology_DATA_ENTRIE = '/entrie';

//-----------

export const Otolaryngology_CATEGORIES_ROUTE = '/otolaryngology';
export const Otolaryngology_DATA_ENTRIE = '/entrie';

//-----------

export const Auscultation_CATEGORIES_ROUTE = '/auscultation';
export const Auscultation_DATA_ENTRIE = '/entrie';

//-----------

export const Dentistry_CATEGORIES_ROUTE = '/dentistry';
export const Dentistry_DATA_ENTRIE = '/entrie';

//-----------

export const Rehabilitation_CATEGORIES_ROUTE = '/rehabilitation';
export const Rehabilitation_DATA_ENTRIE = '/entrie';

//-----------

export const PrenatalDiag_CATEGORIES_ROUTE = '/prenatal';
export const PrenatalDiag_DATA_ENTRIE = '/entrie';
//-----------

export const Terms_PAGE_ROUTE = '/terms';

//-----------

export const Subscribe_PAGE_ROUTE = '/subscribe';

//-----------

const MoodleURL_SDOPIMU = process.env.REACT_APP_MOODLE_URL_SDO;
const MoodleClientID_SDOPIMU = process.env.REACT_APP_MOODLE_CLIENT_ID_SDO;

const MoodleURL_IVGMU = process.env.REACT_APP_MOODLE_URL_IVGMU;
const MoodleClientID_IVGMU = process.env.REACT_APP_MOODLE_CLIENT_ID_IVGMU;

const MoodleURL_KurskSMU = process.env.REACT_APP_MOODLE_URL_KURSKSMU;
const MoodleClientID_KurskSMU = process.env.REACT_APP_MOODLE_CLIENT_ID_KURSKSMU;

const MoodleURL_MarSU = process.env.REACT_APP_MOODLE_URL_MARSU;
const MoodleClientID_MarSU = process.env.REACT_APP_MOODLE_CLIENT_ID_MARSU;

//  Способы авторизации через Moodle. Ключ - это идентификатор клиента, а значением у него будет URL сайта.
export const MoodleAuthTypes = {
    [MoodleClientID_SDOPIMU] : MoodleURL_SDOPIMU,
    [MoodleClientID_IVGMU]: MoodleURL_IVGMU,
    [MoodleClientID_KurskSMU]: MoodleURL_KurskSMU,
    [MoodleClientID_MarSU]: MoodleURL_MarSU,
};